
import { supabase } from "@/integrations/supabase/client";
import { useAuthGuard } from "@/hooks/useAuthGuard";

/**
 * Hook for checking duplicate resumes
 */
export const useDuplicateCheck = () => {
  const { user } = useAuthGuard();

  // Check if a resume with the same filename already exists
  const checkDuplicateResume = async (filename: string): Promise<boolean> => {
    if (!user) return false;
    
    try {
      const { data, error } = await supabase
        .from('resumes')
        .select('id')
        .eq('user_id', user.id)
        .eq('original_filename', filename)
        .eq('is_original', true);
      
      if (error) throw error;
      
      return data && data.length > 0;
    } catch (error) {
      console.error("Error checking for duplicate resume:", error);
      return false;
    }
  };

  return { checkDuplicateResume };
};
